import { type UseQueryOptions, useQuery } from '@tanstack/vue-query'
import type { MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'
import { HR_REMINDERS } from '../reminderEndpoints'
import { REMINDERS_QUERY_KEY } from '../reminderQueryKeys'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { PaginatedRemindersDto } from '@/modules/Reminder/types/api/reminder'

export interface FetchRemindersPaginatedParams {
  pageIndex: number
  pageSize: number
  searchTerm?: string | null
  from?: string | null
  to?: string | null
}

export function fetchRemindersPaginated(
  params: FetchRemindersPaginatedParams
): Promise<PaginatedRemindersDto> {
  return axiosInstance
    .get<PaginatedRemindersDto>(HR_REMINDERS, {
      params: {
        PageIndex: params.pageIndex,
        PageSize: params.pageSize,
        ...(params.searchTerm?.trim()
          ? { SearchTerm: params.searchTerm.trim() }
          : {}),
        ...(params.from ? { From: params.from } : {}),
        ...(params.to ? { To: params.to } : {}),
      },
    })
    .then((response) => response.data)
}

export function useRemindersPaginatedQuery(
  params: MaybeRefOrGetter<FetchRemindersPaginatedParams>,
  options?: Omit<
    UseQueryOptions<Awaited<ReturnType<typeof fetchRemindersPaginated>>>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    queryKey: computed(() => [REMINDERS_QUERY_KEY, toValue(params)]),
    queryFn: () => fetchRemindersPaginated(toValue(params)),
    ...options,
  })
}
